const basicLightbox = require('basiclightbox');

const lightbox = basicLightbox.create('<div class="lightbox"></div>');

// lightbox buttons
document.querySelectorAll('[data-iframe]').forEach((lbTrigger) => {
  lbTrigger.addEventListener('click', (evt) => {
    if (evt.currentTarget.parentNode.parentNode.parentNode.classList.contains('card--active')) { // three levels up
      lightbox.element().innerHTML = `<div class="iframe-container"><div class="iframe-container__inner"><iframe src="${evt.currentTarget.getAttribute('data-iframe')}"></iframe></div></div>`;
      lightbox.show();
    }
  });
});



// WEBPACK FOOTER //
// ./src/javascript/main/lightbox.js